import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DuckSayPWA } from "@ducksay/ducksay-pwa";
import { useAppStore } from "store/appStore";
import Preloader from "components/GlobalPreloader/Preloader";
import showPreviewIcon from "utils/showPreviewImage";

const PhoneContentPwa: React.FC = () => {
  const { appData } = useAppStore();
  const [pwaPreview, setPwaPreview] = useState<any>();

  const currentAppIcon = showPreviewIcon(appData.creatives.icon);
  const currentAppPreviews =
    appData?.creatives?.previews?.map((preview: string | File) => {
      return showPreviewIcon(preview);
    }) || [];

  const updatedAppData = {
    ...appData,
    creatives: {
      ...appData.creatives,
      icon: currentAppIcon,
      previews: currentAppPreviews,
    },
  };

  useEffect(() => {
    setPwaPreview(appData);
  }, [appData, pwaPreview]);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        height: "100%",
        padding: "0",
        zIndex: "3",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          background: "white",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          padding: "0",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {pwaPreview ? <DuckSayPWA pwaData={updatedAppData as any} isPreview={true} /> : <Preloader />}
      </Box>
    </Box>
  );
};

export default PhoneContentPwa;
